'use client'

import { useState, useEffect } from "react";
import Sparkline from "../Sparkline/Sparkline";

const Header = ({ dolar, historicalData, onChartClick }) => {

    const [fecha, setFecha] = useState(null);

    const options = { timeZone: 'America/Santiago' };

    useEffect(() => {
        const fecha = new Date().toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', ...options });
        setFecha(fecha);
    }, []);

    const formattedDolar = dolar ? new Intl.NumberFormat('es-CL').format(dolar) : '---';

    const sparklineData = historicalData && historicalData.length > 0
        ? [...historicalData]
            .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
            .map(item => item.valor)
        : [];

    return (
        <header className="bg-gradient-to-b from-blue-950 to-blue-900 text-white py-4 px-4 w-full">
            <div className="max-w-4xl mx-auto flex items-center justify-between">
                <div>
                    <h1 className="text-sm font-medium text-blue-300">
                        Dólar en Chile
                    </h1>
                    <p className="text-[10px] uppercase tracking-widest text-blue-500">
                        {fecha}
                    </p>
                </div>
                <div className="flex items-center gap-4">
                    {sparklineData.length > 0 && (
                        <div className="flex flex-col items-center cursor-pointer" onClick={onChartClick}>
                            <Sparkline 
                                data={sparklineData} 
                                width={80} 
                                height={28} 
                                color="#3b82f6"
                                onClick={onChartClick}
                            />
                            <span className="text-[8px] text-blue-500 hover:text-blue-300 transition-colors mt-0.5">
                                Ver histórico
                            </span>
                        </div>
                    )}
                    <div className="text-right">
                        <span className="text-2xl md:text-3xl font-bold tracking-tight">
                            ${formattedDolar}
                        </span>
                        <span className="text-sm text-blue-400 font-medium ml-1">
                            CLP
                        </span>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;